export default __webpack_public_path__ + "static/media/Chestplate of the Crimson Fort.c755d8c0.jpg";